import camelcaseKeys from 'camelcase-keys';
import { OfferTypes } from '../types';
import { OFFER_TYPE_DOLLAR, OFFER_TYPE_PERCENT, OFFER_TYPE_PERCENT_DOLLAR, } from '../../components/PaymentCalculator/ViewOffers/constants';
import isNonNullable from '../../utils/isNonNullable';
const additionalSavingsOfferNames = ['Military Discount', 'Newcomer to Canada', 'Student Discount'];
const parseIncentiveOffer = (offer) => {
    let type = OfferTypes[offer.type];
    if (additionalSavingsOfferNames.includes(offer.name)) {
        type = OfferTypes.AdditionalSavings;
    }
    else {
        type = offer.type;
    }
    return {
        ...offer,
        id: Number(offer.id) || 0,
        isSelected: false,
        value: Number(offer.value),
        type,
        key: offer.id.toString(),
    };
};
const parseLoyaltyOffer = (offer) => {
    var _a, _b;
    const loyaltyOfferStub = {
        key: offer.key,
        type: offer.type,
        term: 0,
        id: 0,
        isSelected: false,
    };
    if (offer.type !== OFFER_TYPE_PERCENT_DOLLAR) {
        return {
            ...loyaltyOfferStub,
            ...offer,
            value: Number(offer.value),
        };
    }
    const splitOffers = `${offer.value}`.split(',').map((rawValue, idx) => {
        const value = Number(rawValue.trim());
        if (!value)
            return null;
        const nameSuffix = offer.name.substring(offer.name.indexOf(' '));
        if (idx === 0) {
            return {
                ...loyaltyOfferStub,
                value,
                type: OFFER_TYPE_PERCENT,
                name: `${value * 100}%${nameSuffix}`,
            };
        }
        if (idx === 1) {
            return {
                ...loyaltyOfferStub,
                value,
                type: OFFER_TYPE_DOLLAR,
                name: `$${value}${nameSuffix}`,
            };
        }
        return null;
    });
    return ((_a = splitOffers[1]) === null || _a === void 0 ? void 0 : _a.value) ? splitOffers[1] : (_b = splitOffers[0]) !== null && _b !== void 0 ? _b : null;
};
const defaultOffer = {
    lease: [],
    finance: [],
    cash: [],
};
const transformOffersResponse = (response) => {
    var _a;
    const camelCasedData = camelcaseKeys(response, { deep: true }) || [];
    return (_a = camelCasedData === null || camelCasedData === void 0 ? void 0 : camelCasedData.map) === null || _a === void 0 ? void 0 : _a.call(camelCasedData, item => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        return ({
            ...item,
            loyaltyOffers: item.loyaltyOffers
                ? {
                    ...item.loyaltyOffers,
                    lease: (_d = (_c = (_b = (_a = item.loyaltyOffers) === null || _a === void 0 ? void 0 : _a.lease) === null || _b === void 0 ? void 0 : _b.map(parseLoyaltyOffer)) === null || _c === void 0 ? void 0 : _c.filter(isNonNullable)) !== null && _d !== void 0 ? _d : [],
                    finance: (_h = (_g = (_f = (_e = item.loyaltyOffers) === null || _e === void 0 ? void 0 : _e.finance) === null || _f === void 0 ? void 0 : _f.map(parseLoyaltyOffer)) === null || _g === void 0 ? void 0 : _g.filter(isNonNullable)) !== null && _h !== void 0 ? _h : [],
                    cash: (_m = (_l = (_k = (_j = item.loyaltyOffers) === null || _j === void 0 ? void 0 : _j.cash) === null || _k === void 0 ? void 0 : _k.map(parseLoyaltyOffer)) === null || _l === void 0 ? void 0 : _l.filter(isNonNullable)) !== null && _m !== void 0 ? _m : [],
                }
                : defaultOffer,
            incentiveOffers: item.incentiveOffers
                ? {
                    ...item.incentiveOffers,
                    lease: (_q = (_p = (_o = item.incentiveOffers) === null || _o === void 0 ? void 0 : _o.lease) === null || _p === void 0 ? void 0 : _p.map(parseIncentiveOffer)) !== null && _q !== void 0 ? _q : [],
                    finance: (_t = (_s = (_r = item.incentiveOffers) === null || _r === void 0 ? void 0 : _r.finance) === null || _s === void 0 ? void 0 : _s.map(parseIncentiveOffer)) !== null && _t !== void 0 ? _t : [],
                    cash: (_w = (_v = (_u = item.incentiveOffers) === null || _u === void 0 ? void 0 : _u.cash) === null || _v === void 0 ? void 0 : _v.map(parseIncentiveOffer)) !== null && _w !== void 0 ? _w : [],
                }
                : defaultOffer,
        });
    });
};
export default transformOffersResponse;
